interface DocumentUploadConstructorParameters {
	docName: string;
	docData: Uint8Array;
}

export default class DocumentUpload {
	public docName: string;
	public docData: Uint8Array;

	public constructor(params: DocumentUploadConstructorParameters) {
		this.docName = params.docName;
		this.docData = params.docData;
	}
}